/* Mobile Side Tabs interactions */
(function(){
  const MOBILE_MQ = '(max-width: 749px)';

  const getOrCreateGlobalLightbox = () => {
    let lb = document.querySelector('[data-mobile-side-tabs-lightbox]');
    if (lb) return lb;

    lb = document.createElement('div');
    lb.className = 'mobile-side-tabs__lightbox';
    lb.setAttribute('data-mobile-side-tabs-lightbox', '');
    lb.setAttribute('hidden', '');
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');

    const img = document.createElement('img');
    img.setAttribute('alt', '');
    lb.appendChild(img);

    lb.addEventListener('click', () => {
      lb.setAttribute('hidden', '');
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (lb.hasAttribute('hidden')) return;
      lb.setAttribute('hidden', '');
    });

    document.body.appendChild(lb);
    return lb;
  };

  const openLightbox = (src) => {
    if (!src) return;
    const lb = getOrCreateGlobalLightbox();
    const lbImg = lb.querySelector('img');
    if (!lbImg) return;
    lbImg.src = src;
    lb.removeAttribute('hidden');
  };

  const initSection = (root) => {
    if (!root) return;

    // Mobile: tap image to enlarge (fallback is anchor opening a large image)
    root.addEventListener('click', (e) => {
      if (!window.matchMedia || !window.matchMedia(MOBILE_MQ).matches) return;
      const link = e.target && e.target.closest && e.target.closest('a.mobile-side-tabs__mobile-media-btn');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      e.preventDefault();
      e.stopPropagation();

      openLightbox(href);
    });

    const tabButtons = root.querySelectorAll('[role="tab"]');
    const panels = root.querySelectorAll('[role="tabpanel"]');

    const publishCartUpdate = (variantId, cartData) => {
      if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      try {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'mobile-side-tabs',
          productVariantId: variantId,
          cartData,
        });
      } catch (e) {
        // ignore
      }
    };

    const syncCartDrawerEmptyState = (cartData) => {
      try {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        const count = Number(cartData && cartData.item_count) || 0;
        drawer.classList.toggle('is-empty', count === 0);
      } catch (e) {
        // ignore
      }
    };

    const notifyFloatingCart = () => {
      try {
        window.dispatchEvent(new CustomEvent('mobile-floating-cart:refresh'));
      } catch (e) {
        // ignore
      }
    };

    const fetchCart = async () => {
      const res = await fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      });
      if (!res.ok) throw new Error('cart_fetch_failed');
      return res.json();
    };

    const findItemByVariantId = (cart, variantId) => {
      const id = Number(variantId);
      if (!cart || !Array.isArray(cart.items)) return null;
      for (let i = 0; i < cart.items.length; i++) {
        const item = cart.items[i];
        if (Number(item.variant_id) === id) {
          return { line: i + 1, quantity: Number(item.quantity) || 0 };
        }
      }
      return null;
    };

    const updateQtyControl = (qtyWrap, quantity) => {
      const valueEl = qtyWrap.querySelector('.mobile-side-tabs__qty-value');
      const minus = qtyWrap.querySelector('.mobile-side-tabs__qty-minus');
      if (valueEl) valueEl.textContent = String(quantity);
      if (minus) {
        const disabled = quantity <= 0;
        minus.disabled = disabled;
        minus.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
    };

    const refreshVisibleQtyControls = async () => {
      const visiblePanel = root.querySelector('[role="tabpanel"]:not([hidden])');
      if (!visiblePanel) return;
      const qtyWraps = visiblePanel.querySelectorAll('.mobile-side-tabs__qty[data-variant-id]');
      if (!qtyWraps.length) return;

      const cart = await fetchCart();
      qtyWraps.forEach((wrap) => {
        const variantId = wrap.getAttribute('data-variant-id');
        const item = findItemByVariantId(cart, variantId);
        updateQtyControl(wrap, item ? item.quantity : 0);
      });

      return cart;
    };

    const selectTab = (id) => {
      tabButtons.forEach(btn => {
        const selected = btn.getAttribute('data-tab') === id;
        btn.setAttribute('aria-selected', selected ? 'true' : 'false');
        btn.setAttribute('tabindex', selected ? '0' : '-1');
      });
      panels.forEach(p => {
        if (p.getAttribute('data-tab') === id) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });

      // 切换 Tab 后刷新当前面板的数量显示
      refreshVisibleQtyControls().catch(() => {});
    };

    tabButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const id = btn.getAttribute('data-tab');
        selectTab(id);
      });
    });

    // 默认选中第一个
    if (tabButtons.length) selectTab(tabButtons[0].getAttribute('data-tab'));

    // 移动端：+/- 同步购物车
    root.addEventListener('click', async (e) => {
      const btn = e.target.closest('.mobile-side-tabs__qty-plus, .mobile-side-tabs__qty-minus');
      if (!btn) return;

      e.preventDefault();
      if (btn.disabled) return;

      const qtyWrap = btn.closest('.mobile-side-tabs__qty');
      if (!qtyWrap) return;

      const variantId = qtyWrap.getAttribute('data-variant-id');
      if (!variantId) return;

      const isPlus = btn.classList.contains('mobile-side-tabs__qty-plus');
      const isMinus = btn.classList.contains('mobile-side-tabs__qty-minus');
      if (!isPlus && !isMinus) return;

      const plus = qtyWrap.querySelector('.mobile-side-tabs__qty-plus');
      const minus = qtyWrap.querySelector('.mobile-side-tabs__qty-minus');
      if (plus) plus.disabled = true;
      if (minus) minus.disabled = true;

      try {
        const cart = await fetchCart();
        const item = findItemByVariantId(cart, variantId);
        const currentQty = item ? item.quantity : 0;

        if (isMinus && currentQty <= 0) {
          updateQtyControl(qtyWrap, 0);
          return;
        }

        if (isPlus && item) {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ line: item.line, quantity: currentQty + 1 })
          });
          if (!res.ok) return;
          const updated = await res.json();
          const updatedItem = findItemByVariantId(updated, variantId);
          updateQtyControl(qtyWrap, updatedItem ? updatedItem.quantity : 0);
          publishCartUpdate(variantId, updated);
          syncCartDrawerEmptyState(updated);
          notifyFloatingCart();
          return;
        }

        if (isMinus && item) {
          const nextQty = Math.max(0, currentQty - 1);
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ line: item.line, quantity: nextQty })
          });
          if (!res.ok) return;
          const updated = await res.json();
          const updatedItem = findItemByVariantId(updated, variantId);
          updateQtyControl(qtyWrap, updatedItem ? updatedItem.quantity : 0);
          publishCartUpdate(variantId, updated);
          syncCartDrawerEmptyState(updated);
          notifyFloatingCart();
          return;
        }

        // isPlus but item not in cart yet
        if (isPlus) {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });
          if (!res.ok) return;
          const cart = await refreshVisibleQtyControls();
          if (cart) publishCartUpdate(variantId, cart);
          if (cart) syncCartDrawerEmptyState(cart);
          notifyFloatingCart();
        }
      } catch (err) {
        // ignore
      } finally {
        // 先解除禁用，状态再由 updateQtyControl 决定 minus 是否可点
        if (plus) plus.disabled = false;
        if (minus) minus.disabled = false;
        refreshVisibleQtyControls().catch(() => {});
      }
    });
  };

  const boot = () => {
    document.querySelectorAll('.mobile-side-tabs').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
